import { call, put, takeLatest } from 'redux-saga/effects';
import apiRequests from 'config/services';              // make sure this exports getSingleEntityMatch
import { setInterpreterResult } from 'store/slices/interpreterResultSlice';
import { sagaInterpretBomInputAction } from 'saga/actions/interpreter';
import { iInterpreterResult } from 'store/types/interpreter';
import { interpreterConstants } from 'saga/actions/interpreter';

export function* interpretBomInputSaga(action: ReturnType<typeof sagaInterpretBomInputAction>) {
  try {
    const { bomData } = action.payload;
    // call your API helper
    const response: iInterpreterResult = yield call(
      apiRequests.interpretBomInput,
      bomData
    );
    yield put(setInterpreterResult(response));
  } catch (e) {
    console.error('interpreter saga error', e);
  }
}

export function* interpreterSagaHook() {
  yield takeLatest(interpreterConstants.SAGA_INTERPRET_BOM_INPUT, interpretBomInputSaga);
}
